import { render } from "./withdrawFunds.vue?vue&type=template&id=f4890da8&scoped=true"
import script from "./withdrawFunds.vue?vue&type=script&lang=js"
export * from "./withdrawFunds.vue?vue&type=script&lang=js"

import "./withdrawFunds.vue?vue&type=style&index=0&id=f4890da8&lang=scss&scoped=true"

import exportComponent from "E:\\zhouwang\\work\\web_dev\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4890da8"]])

export default __exports__